module.exports = __webpack_public_path__ + "static/media/Station.617620c4.png";